import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {
  IGetDocument,
  IRating,
  ISearchDocument,
} from '../models/document.model';
import {ITableDataApiRes} from '../models/http.model';
import {HttpService} from './http.service';

@Injectable({
  providedIn: 'root',
})
export class DocumentService {
  logo = '';

  constructor(private httpService: HttpService) {
  }

  getDocument(params: ISearchDocument): Observable<ITableDataApiRes> {
    return this.httpService.get('/student/documents/search', params);
  }

  getMyDocument(params: ISearchDocument): Observable<ITableDataApiRes> {
    return this.httpService.get('/student/documents', params);
  }

  createDocument(courseId: string): Observable<ITableDataApiRes> {
    return this.httpService.post('/student/documents/' + courseId);
  }

  putDocument(
    courseId: string,
    bodyData: IRating
  ): Observable<ITableDataApiRes> {
    return this.httpService.put(`/student/documents/${courseId}`, bodyData);
  }

  getLogo() {
    return this.httpService.get('/share/settings')
  }

  setLogoPage(logo: string) {
    this.logo = logo;
  }

  getLogoPage() {
    return this.logo
  }

  uploadFile(formData: FormData) {
    return this.httpService.upload('/media/teacher/upload', formData);
  }

  getFileSetting() {
    return this.httpService.get('/share/settings/file')
  }
}
